import { images } from './ImageUrls';

export const bundleId = 3269;

export const imageSpriteUrl = images.combinee;

export const productsToGenerateForTesting = [
  {
    params: {
      // brand: "care",
      product: 'stretch-marks-cream-with-saffron-shea-butter-kokum-100-gm-280',
    },
  },
];
export const productsToGenerateForBuild = [
  {
    params: {
      // brand: "care",
      product: 'stretch-marks-cream-with-saffron-shea-butter-kokum-100-gm-280',
    },
  },
];
export const clinicToGenerateForTesting = [
  {
    params: {
      type: 'surgeries-procedures',
      package: 'ivf-treatment-547',
    },
  },
  {
    params: {
      type: 'diagnostics-tests',
      package: 'thyroid-screening-274',
    },
  },
  {
    params: {
      type: 'health-packages',
      package: '2-Months-Postpartum-Weight-Loss-Plan-1268',
    },
  },
];
export const widgetVersionObj = {
  aPlusPlus: 1,
  aPlus: 2,
};
export const hardcodedOfferData = [
  {
    offer_heading: 'FREE Winter Baby Massage Oil worth ₹379',
    name: 'FREE Winter Baby Massage Oil worth ₹379',
    description: [
      "Get Mylo's Bestseller Ayurvedic Baby Massage Oil - Lakshadi Thailam (100mL)",
      'Valid on purchases above ₹799 only till 31st June',
    ],
    img: 'https://images.myloapp.in/NestJsUploads/1670415229006-lakshadi_thailam.webp',
    code: 'LAKSHADI',
    // forSku: [1288, 2588, 1289, 1290, 2929, 2928],
    forSku: [],
  },
  {
    offer_heading: 'FREE Coconut Oil worth ₹349',
    name: 'FREE Coconut Oil worth ₹349',
    description: [
      "Get Mylo's Bestseller Cold Pressed Extra Virgin Coconut Oil (200mL)",
      'Valid on this purchase till the stock lasts',
    ],
    img: 'https://images.myloapp.in/NestJsUploads/1698397527873-wrapper-freebie.webp',
    code: 'COCO',
    // forSku: [1288, 2588, 1289, 1290],
    forSku: [],
  },
  {
    offer_heading: 'FREE Face Wash worth ₹249',
    name: 'FREE Face Wash worth ₹249',
    description: [
      "Mylo's bestseller Ubtan facewash with the goodness of saffron, turmeric, and nalpamaradi oil",
      'Valid on purchases above ₹599 only till 31st June',
    ],
    img: 'https://images.myloapp.in/NestJsUploads/1670415305980-ubtan_face_wash.webp',
    code: 'UBTANFW',
    // forSku: [979],
    forSku: [],
  },
];

export const clinicsToGenerateForBuildInt = [
  {
    params: {
      packageName: 'post-pregnancy-weight-loss-plan-international-3186',
      clinicPage: 'health-packages',
    },
  },
];

export const hidPdpOfferABSkus = [2890, 2891, 2892, 2893, bundleId];

export const recent_viewed_key = 'recent_viewed_products';

export const bathTubFreebieData = {
  code: 'BABYCARE',
  name: 'FREE Mylo Baby Bath Essentials Kit (worth ₹448)',
  expire_date: 'Offer valid till stocks last',
  description: [
    [
      '1 Mylo Care Baby Wash & Shampoo - 200 ml',
      '1 Mylo Care Baby Lotion - 200 ml',
    ],
    ["Gently cleanses baby's skin & hair"],
  ],
  banner_image:
    'https://images.myloapp.in/NestJsUploads/1698397527872-bathtub-freebie.webp',
};

export const hardCodeCanonicalUrls = {
  3662: 'https://mylofamily.com/product/ovaluna-pack-of-3-3663',
  3408: 'https://mylofamily.com/product/ovaluna-pack-of-3-3663',

  // 3152: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3150: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3725: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3475: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3483: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3482: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 2380: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3459: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3476: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3485: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 2378: "https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378",
  2378: 'https://mylofamily.com/product/mylo-baby-diapers-pants-small-size',
  // 3486: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3742: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3484: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 2381: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 2379: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3149: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3481: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3151: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3483: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3484: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3485: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3486: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3866: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3865: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3864: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3863: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3862: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3861: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3860: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3859: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3858: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3855: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3854: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3853: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3475: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3482: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3481: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  // 3476: 'https://mylofamily.com/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
  3928:'https://mylofamily.com/category/lactomama-lactation-granules'


  // 3511: "https://mylofamily.com/product-category/baby-soap",

  // 1119: "https://mylofamily.com/product-category/baby-carrier",
  // 1120: "https://mylofamily.com/product-category/baby-carrier",
  // 2436: "https://mylofamily.com/product-category/baby-carrier",
  // 2437: "https://mylofamily.com/product-category/baby-carrier",
  // 2438: "https://mylofamily.com/product-category/baby-carrier",
  // 2439: "https://mylofamily.com/product-category/baby-carrier",
  // 2440: "https://mylofamily.com/product-category/baby-carrier",
  // 2441: "https://mylofamily.com/product-category/baby-carrier",
  // 3204: "https://mylofamily.com/product-category/baby-carrier",
  // 3205: "https://mylofamily.com/product-category/baby-carrier",
  // 3206: "https://mylofamily.com/product-category/baby-carrier",
  // 3207: "https://mylofamily.com/product-category/baby-carrier",
  // 3433: "https://mylofamily.com/product-category/baby-carrier",
  // 3434: "https://mylofamily.com/product-category/baby-carrier",

  // 381: "https://mylofamily.com/product-category/baby-shampoo",
  // 2049: "https://mylofamily.com/product-category/baby-shampoo",
  // 2050: "https://mylofamily.com/product-category/baby-shampoo",
  // 2986: "https://mylofamily.com/product-category/baby-shampoo",

  // 2987: "https://mylofamily.com/product-category/baby-lotion",
  // 2994: "https://mylofamily.com/product-category/baby-lotion",
  // 283: "https://mylofamily.com/product-category/baby-lotion",

  // 450: "https://mylofamily.com/product-category/baby-powder",
  // 3534: "https://mylofamily.com/product-category/baby-powder",

  // 280: "https://mylofamily.com/product-category/stretch-marks-cream",
  // 758: "https://mylofamily.com/product-category/stretch-marks-cream",
  // 979: "https://mylofamily.com/product-category/stretch-marks-cream",
  // 3162: "https://mylofamily.com/product-category/stretch-marks-cream",
  // 3163: "https://mylofamily.com/product-category/stretch-marks-cream",

  // 847: "https://mylofamily.com/product-category/stretch-marks-oil",

  // 1093: "https://mylofamily.com/product-category/baby-cream",

  // 2426: "https://mylofamily.com/product-category/baby-massage-oil",
  // 3523: "https://mylofamily.com/product-category/baby-massage-oil",

  // 1094: "https://mylofamily.com/product-category/baby-hair-oil",
  // 3523: "https://mylofamily.com/product-category/baby-hair-oil",
};

export const lotionFootnoteTable = `<br />
    <table border='1'>
      <tr>
        <th> Products </th>
        <th> Price </th>
        <th> % Discount </th>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/gentle-baby-wipes-with-organic-coconut-oil-neem-without-lid-80-wipes-x-3-packs-789>Gentle Baby Wipes with Organic Coconut Oil & Neem Without Lid (80 wipes x 3 packs)</a>
        </td>
        <td> ₹275 </td>
        <td> 38% </td>
      </tr>
      
      
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-lotion-200-ml---pack-of-2-2987>Baby Lotion- Pack of 2 (200 ml)</a>
        </td>
        <td> ₹529 </td>
        <td> 25% </td>
      </tr>
      
      
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-bathing-combo-3187>Baby Bathing Super Saver Combo - Body Wash & Shampoo, Towel, Lotion & Powder</a>
        </td>
        <td> ₹1119 </td>
        <td> 23% </td>
      </tr>
      
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-essentials-gift-set-964>Baby Essentials Gift Set</a>
        </td>
        <td> ₹959 </td>
        <td> 36% </td>
      </tr>
      
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/stretch-marks-cream-with-saffron-shea-butter-kokum-100-gm-280>Stretch Marks Cream with Saffron, Shea Butter & Kokum (100 gm)</a>
        </td>
        <td> ₹329 </td>
        <td> 34% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/stretch-marks-day-night-kit-oil-100-ml-cream-100-gm-979>Stretch Marks- Day & Night Kit - Oil (100 ml) & Cream (100 gm)</a>
        </td>
        <td> ₹649 </td>
        <td> 23% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/tea-tree-face-wash-with-neem-magnolia-bark-lemongrass-100-gm-862>Tea Tree Face Wash with Neem, Basil & Lemongrass (100 gm)</a>
        </td>
        <td> ₹209 </td>
        <td> 16% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/cold-pressed-extra-virgin-coconut-oil-for-skin-hair-200-ml-211>Cold Pressed Extra Virgin Coconut Oil for Skin & Hair (200 ml)</a>
        </td>
        <td> ₹349 </td>
        <td> 0% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/onion-hairfall-control-oil-with-bhringraj-argan-hairy-root-culture-castor-200-ml-286>Onion Oil (200 ml)</a>
        </td>
        <td> ₹469 </td>
        <td> 6% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-tummy-roll-on-with-hing-saunf-pudina-for-indigestion-colic-40-ml-284>Tummy Roll-on (40 ml)</a>
        </td>
        <td> ₹199 </td>
        <td> 20% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/onion-hair-fall-control-shampoo-with-bhringraj-plant-keratin-hairy-root-extract-200-ml-451>Onion Shampoo (200 ml)</a>
        </td>
        <td> ₹299 </td>
        <td> 14% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/vitamin-c-brightening-face-wash-100-ml-731>Vitamin C Refreshing & Brightening Face Wash (100 ml)</a>
        </td>
        <td> ₹239 </td>
        <td> 4% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-lotion-200-ml---pack-of-2-2994>Baby Bath Essentials - Baby Body Wash & Shampoo (200 ml) and Mylo Care Baby Lotion (200 ml)</a>
        </td>
        <td> ₹448 </td>
        <td> 0% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/100-natural-baby-hair-oil-100-ml-1094>100% Natural Baby Hair Oil (100 ml)</a>
        </td>
        <td> ₹249 </td>
        <td> 17% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-body-wash-shampoo-200ml-381> Body Wash & Shampoo (200ml)</a>
        </td>
        <td> ₹299 </td>
        <td> 14% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-tummy-roll-on-with-hing-saunf-pudina-for-indigestion-colic-40-ml-284>Tummy Roll-on (40 ml)</a>
        </td>
        <td> ₹199 </td>
        <td> 20% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mosquito-repellent-spray-100-ml-908>Mosquito Repellent Spray (100 ml) </a>
        </td>
        <td> ₹179 </td>
        <td> 28% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-massage-oil-200ml-2426>Baby Massage Oil 200ml</a>
        </td>
        <td> ₹375 </td>
        <td> 16% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-face-cream-100g-1093>Baby Face Cream 100g </a>
        </td>
        <td> ₹149 </td>
        <td> 25% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-bathing-combo-3187>Baby Bathing Super Saver Combo - Body Wash & Shampoo, Towel, Lotion & Powder</a>
        </td>
        <td> ₹1119 </td>
        <td> 23% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-baby-soap-75g---for-0-3-years-with-vitamin-e-murumuru-butter-jojoba-oil-coconut-oil---pack-of-3-3687>Mylo Baby Soap 75g - For 0-3 years with Vitamin E, Murumuru Butter, Jojoba Oil & Coconut Oil - Pack of 3</a>
        </td>
        <td> ₹190 </td>
        <td> 3% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-talc-free-powder-with-oatmeal-lavander-and-tea-tree-oil-300-gm-450>Baby Natural Talc-Free Powder 300 gm </a>
        </td>
        <td> ₹275 </td>
        <td> 21% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-gentle-baby-laundry-detergent-1ltr-1097>Gentle Baby Laundry Detergent 1Ltr</a>
        </td>
        <td> ₹399 </td>
        <td> 11% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/100-natural-mosquito-repellent-patches-pack-of-24-907> Mosquito Repellent Patches (Pack of 24)</a>
        </td>
        <td> ₹149 </td>
        <td> 25% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-diaper-rash-cream-with-aloe-vera-almond-oil-vitamin-e-50-gm-281>Diaper Cream 50g</a>
        </td>
        <td> ₹219 </td>
        <td> 22% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mosquito-repellent-combo-1207>Mosquito Repellent Combo </a>
        </td>
        <td> ₹289 </td>
        <td> 35% </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/body-wash-shampoo-200ml---pack-of-2-2986> Body Wash & Shampoo (200ml) - Pack of 2</a>
        </td>
        <td> ₹499 </td>
        <td> 29% </td>
      </tr>
    </table>
    <p> This data was last updated on 12/12/2023</p>
    `;
export const faqsDataLotion = ` <h3>
<span style="color:#000000">
  <strong>FAQs&nbsp;</strong>
</span>
</h3>
<h4>
<span>
  <strong>1.&nbsp</strong>
</span>
<strong>Where all can I apply the Mylo Baby Lotion?</strong>
</h4>
<p>
<span style="color: black;">You can apply the lotion everywhere on the body except the face and private parts of your baby.</span>
</p>
<h4>
<span>
  <strong>2.&nbsp</strong>
</span>
<strong>Can I use this Baby Body Lotion every day?</strong>
</h4>
<p>
<span style="color: black;">Yes, you can use it every day.</span>
</p>
<h4>
<span>
  <strong>3.&nbsp</strong>
</span>
<strong>Is this Baby Moisturizing Cream suitable for newborns?</strong>
</h4>
<p>
<span style="color: black;">Yes, you can use it for newborns as well.</span>
</p>
<h4>
<span>
  <strong>4.&nbsp</strong>
</span>
<strong>Can I use this Baby Lotion for Dry Skin?</strong>
</h4>
<p>
<span style="color: black;">Yes, it is especially helpful in soothing skin dryness and conditions like eczema and psoriasis.</span>
</p>



<h4>
<span>
  <strong>5.&nbsp</strong>
</span>
<strong>Which is the best whitening lotion for babies?</strong>
</h4>
<p>
<span style="color: black;">It’s important to understand that a baby’s skin complexion is determined by genetics and cannot be changed by a lotion, oil or soap.</span>
</p>



<h4>
<span>
  <strong>6.&nbsp</strong>
</span>
<strong>Is this baby lotion for winter? </strong>
</h4>
<p>
<span style="color: black;">Yes, you can use this lotion for your baby in winter.</span>
</p>



<h4>
<span>
  <strong>7.&nbsp</strong>
</span>
<strong>What is the Mylo Baby Lotion price?</strong>
</h4>
<p>
<span style="color: black;">You can get 200ml of Mylo’s baby body lotion for Rs. 349.</span>
</p>




`;

export const ratingTableLotion = `<br />
    <table border='1'>
      <tr>
        <th> Products </th>
        <th> Rating </th>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/cold-pressed-extra-virgin-coconut-oil-for-skin-hair-200-ml-211>Cold Pressed Extra Virgin Coconut Oil for Skin & Hair (200 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/stretch-marks-cream-with-saffron-shea-butter-kokum-100-gm-280>Stretch Marks Cream with Saffron, Shea Butter & Kokum (100 gm)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-diaper-rash-cream-with-aloe-vera-almond-oil-vitamin-e-50-gm-281>Diaper Cream 50g</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-tummy-roll-on-with-hing-saunf-pudina-for-indigestion-colic-40-ml-284>Tummy Roll-on (40 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/onion-hairfall-control-oil-with-bhringraj-argan-hairy-root-culture-castor-200-ml-286>Onion Oil (200 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-body-wash-shampoo-200ml-381> Body Wash & Shampoo (200ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-natural-talc-free-powder-with-oatmeal-lavander-and-tea-tree-oil-300-gm-450>Baby Natural Talc-Free Powder 300 gm </a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/onion-hair-fall-control-shampoo-with-bhringraj-plant-keratin-hairy-root-extract-200-ml-451>Onion Shampoo (200 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/vitamin-c-brightening-face-wash-100-ml-731>Vitamin C Refreshing & Brightening Face Wash (100 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/gentle-baby-wipes-with-organic-coconut-oil-neem-without-lid-80-wipes-x-3-packs-789>Gentle Baby Wipes with Organic Coconut Oil & Neem Without Lid (80 wipes x 3 packs)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/tea-tree-face-wash-with-neem-magnolia-bark-lemongrass-100-gm-862>Tea Tree Face Wash with Neem, Basil & Lemongrass (100 gm)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/100-natural-mosquito-repellent-patches-pack-of-24-907> Mosquito Repellent Patches (Pack of 24)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mosquito-repellent-spray-100-ml-908>Mosquito Repellent Spray (100 ml) </a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-essentials-gift-set-964>Baby Essentials Gift Set</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/stretch-marks-day-night-kit-oil-100-ml-cream-100-gm-979>Stretch Marks- Day & Night Kit - Oil (100 ml) & Cream (100 gm)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-face-cream-100g-1093>Baby Face Cream 100g </a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/100-natural-baby-hair-oil-100-ml-1094>100% Natural Baby Hair Oil (100 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-gentle-baby-laundry-detergent-1ltr-1097>Gentle Baby Laundry Detergent 1Ltr</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mosquito-repellent-combo-1207>Mosquito Repellent Combo </a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-massage-oil-200ml-2426>Baby Massage Oil 200ml</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/body-wash-shampoo-200ml---pack-of-2-2986> Body Wash & Shampoo (200ml) - Pack of 2</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-lotion-200-ml---pack-of-2-2987>Baby Lotion- Pack of 2 (200 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-care-baby-lotion-200-ml---pack-of-2-2994>Baby Bath Essentials - Baby Body Wash & Shampoo (200 ml) and Mylo Care Baby Lotion (200 ml)</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/baby-bathing-combo-3187>Baby Bathing Super Saver Combo - Body Wash & Shampoo, Towel, Lotion & Powder</a>
        </td>
        <td> 4/5 </td>
      </tr>
      <tr>
        <td>
          <a target='_blank' href=https://mylofamily.com/product/mylo-baby-soap-75g---for-0-3-years-with-vitamin-e-murumuru-butter-jojoba-oil-coconut-oil---pack-of-3-3687>Mylo Baby Soap 75g - For 0-3 years with Vitamin E, Murumuru Butter, Jojoba Oil & Coconut Oil - Pack of 3</a>
        </td>
        <td> 4/5 </td>
      </tr>
    </table>`;

export const BrandName = 'Mylo - Raise Happiness';
